let apiBase = '/api/onapi/'

if (process.env.NODE_ENV === 'development') {
  apiBase = 'http://localhost:8080' + apiBase
}

module.exports = {
  api_base: apiBase,
  product: 'Flow-Access'
}
//"activation_api_base": "http://192.168.22.45:8082/",
//"api_base": "http://localhost:8080/api/onapi",



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/config/installation.js